const API_ERRORS = [
    {code: 'CLIENT_SELF_REMOVAL:PHONE:NOT_VALID', message: 'Podany nr telefonu jest nieprawidłowy'},
    {code: 'CLIENT_SELF_REMOVAL:SMS:LIMIT_EXCEEDED', message: 'Zbyt wiele prób. Twój numer telefonu został zablokowany. Spróbuj ponownie za 24h'},
    {code: 'CLIENT_SELF_REMOVAL:VERIFICATION_CODE:NOT_VALID', message: 'Kod weryfikacyjny jest niepoprawny. Wprowadź kod ponownie'},
    {code: 'CLIENT_SELF_REMOVAL:CAPTCHA:NOT_VALID', message: 'Pole weryfikacji jest wymagane'},
];

export default API_ERRORS;